//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from "assets/img/logo.png";
import { consentStyles } from "./styles";
import auth from "apis/auth/auth";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";

export default function MembershipUnassigned() {
  const { membershipUnassigned } = auth();
  const classes = consentStyles();
  const location = useLocation();
  const { t } = useTranslation();
  const param = new URLSearchParams(location.search);
  const token = param.get("token");

  useEffect(() => {
    i18n.changeLanguage(param.get("lang"));
  }, []);


  const handleGetData = async () => {
    try {
      let res = await membershipUnassigned({ token });
      if (res?.type == "success") {
        window.location.replace(res?.referrerUrl);
      }
    } catch (e) {
      console.log({ e });
    }
  };

  return (
    <div className={classes.mainDiv}>
      <img src={Logo} height="300" alt="logo" />
      <Card className={classes.card}>
        <div className={classes.divText}>{t("Customer Web Notice")}</div>
        <div className={classes.divSubText} style={{ textAlign: 'center' }}>
          {t("Thank you for your interest in the Henry Schein Thrive Rewards program. Your tier was unassigned.")}
        </div>
        {/* <Button
          className={classes.enrollBtn}
          onClick={() => {
            handleGetData();
          }}
        >
          Go Back
        </Button> */}
      </Card>
    </div>
  );
}
